import { gql } from '@apollo/client'
import { DRAW_MAP_TASK_FRAGMENT } from '../fragments/DrawMapTaskFragment'

export const UPDATE_INDOOR_MAP_DRAW_TASK = gql`
  mutation UpdateIndoorMapDrawTask($input: UpdateIndoorMapDrawTaskInput!) {
    updateIndoorMapDrawTask(input: $input) {
      indoorMapDrawTask {
        ...DrawMapTask
      }
    }
  }
  ${DRAW_MAP_TASK_FRAGMENT}
`
